module.exports = __webpack_public_path__ + "static/media/GreenCopyIcon.71e594cb.svg";